import React, { createContext, useCallback, useContext, useState } from 'react'

export const DEFAULT_RECIPE_QUERY = 'steak'

const STORAGE_KEY = 'yummtime:last-recipe-query'
const RecipeSearchContext = createContext(null)

const normalizeQuery = (value) => {
  const normalized = String(value || '').trim()
  return normalized || DEFAULT_RECIPE_QUERY
}

const getInitialQuery = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_RECIPE_QUERY
  }

  try {
    return normalizeQuery(window.sessionStorage.getItem(STORAGE_KEY))
  } catch {
    return DEFAULT_RECIPE_QUERY
  }
}

export const RecipeSearchProvider = ({ children }) => {
  const [query, setQueryState] = useState(getInitialQuery)

  const setQuery = useCallback((nextQuery) => {
    setQueryState((previousQuery) => {
      const resolvedQuery = typeof nextQuery === 'function'
        ? nextQuery(previousQuery)
        : nextQuery
      const normalizedQuery = normalizeQuery(resolvedQuery)

      try {
        window.sessionStorage.setItem(STORAGE_KEY, normalizedQuery)
      } catch {
        // Session persistence is best-effort; in-memory state still works.
      }

      return normalizedQuery
    })
  }, [])

  return (
    <RecipeSearchContext.Provider value={{ query, setQuery }}>
      {children}
    </RecipeSearchContext.Provider>
  )
}

export const useRecipeSearch = () => {
  const context = useContext(RecipeSearchContext)

  if (!context) {
    throw new Error('useRecipeSearch must be used within RecipeSearchProvider')
  }

  return context
}
